import axios from 'axios'

export default class Rest {
    constructor (config) {
        this.config = config

        this.basePath = config.basePath
        this.authToken = config.authToken
        this.authType = config.authType || 'Bearer'

        this.axiosInstance = axios.create(config)
        this.enableInterceptors()

        this.setAuthorizationHeaders()
    }

    enableInterceptors () {
        this.axiosInstance.interceptors.response.use((response) => {
            return response
        }, (error) => {
            return this.handleError(error)
        })
    }

    handleError (error) {
        console.log('ERROR')
        console.log(error)

        // If it's an authorization error, reset the token
        if (((error || {}).response || {}).status === 401) {
            console.log('Not Authorized')
            // Reset the authorization headers and apply to the request we are about to "retry"
            var headers = (((error || {}).config || {}).headers || {})
            headers.Authorization = this.setAuthorizationHeaders()
        }

        return this.retry(error)
    }

    retry (error) {
        let output = null
        const config = (error || {}).config

        // If no previous request (represented by config) is found, then do nothing
        if (config) {
            // Increment (or create for the first time) a retry count
            config.__retryCount = (config.__retryCount || 0) + 1

            // Retry it twice before failing completely
            if (config.__retryCount <= 2) {
                output = this.axiosInstance.request(config)
            }
        }

        // We aren't handling this one, so pass the error through
        if (output === null) {
            output = Promise.reject(error)
        }

        return output
    }

    setAuthorizationHeaders () {
        if (this.authToken) {
            let authorization = this.authToken

            if (this.isFunction(this.authToken)) {
                authorization = this.authToken()
            }

            if (this.authType === 'Bearer') {
                authorization = `Bearer ${authorization}`
            }

            this.axiosInstance.defaults.headers.common.Authorization = authorization
        }

        return this.axiosInstance.defaults.headers.common.Authorization
    }

    request (requestConfig) {
        const promise = new Promise((resolve, reject) => {
            this.axiosInstance.request(requestConfig)
            .then(response => {
                console.log(response)
                resolve(response.data)
            })
            .catch(error => {
                console.log(error)
                reject(error)
            })
            .finally(() => {
                console.log('done')
            })
        })

        return promise
    }

    isFunction (functionToCheck) {
      return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]'
    }

    go (endpoint, method, payload = null) {
        const requestConfig = {
            url: `${this.basePath}${endpoint}`,
            method: method,
        }

        if (payload) {
            switch (method) {
                case 'get':
                    requestConfig.params = payload
                    break
                default: // put, post, patch, delete
                    requestConfig.data = payload
            }
        }

        return this.request(requestConfig)
    }

    // Used for selecting a single resource or a list of resources
    get (endpoint, params = null) {
        return this.go(endpoint, 'get', params)
    }

    // Put will modify a resource entirely, or create a new one
    put (endpoint, data = null) {
        return this.go(endpoint, 'put', data)
    }

    // Patch will modify one element of a resource
    patch (endpoint, data = null) {
        return this.go(endpoint, 'patch', data)
    }

    // Post Creates new resource
    post (endpoint, data = null) {
        return this.go(endpoint, 'post', data)
    }

    // Delete removes resource
    delete (endpoint, data = null) {
        return this.go(endpoint, 'delete', data)
    }
}
